import React, { useEffect, useState } from "react";
import Images from "../../../Images";
import {
  CombineInputGroup,
  InputGroup,
  Label,
  SubmitBtn,
} from "../../../Components/Styles/InputStyles";
import * as Yup from "yup";
import MenuItem from "@mui/material/MenuItem";
import Select from "@mui/material/Select";
import moment from "moment";
import { useFormik } from "formik";
import tw from "tailwind-styled-components";
import { toast } from "react-toastify";

export default function OccupationDetails({
  tenantData,
  setSelectedData,
  editOccupationDetailMutate,
  isOccupationDetailLoading,
  e
}
) {


  const occupationFormik = useFormik({
    initialValues: {
      occupation: tenantData?.occupation === 'Professional' ? '2' : tenantData?.occupation === 'Student' ? '1' : tenantData?.occupation,
      institutionName: tenantData?.institutionName || "",
      institutionEmail: tenantData?.institutionEmail || "",
      courseName: tenantData?.title || "",
      monthlyIncome: tenantData?.monthlyIncome || "",
      incomeSource: tenantData?.incomeSource || "",
    },
    validationSchema: Yup.object({
      occupation: Yup.string(),
      institutionName: Yup.string(),
      institutionEmail: Yup.string(),
      courseName: Yup.string(),
      //   occupation: Yup.string().required("Occupation is required"),
      //   institutionName: Yup.string().required("Company/Institution Name is required"),
      //   courseName: Yup.string().required("Work Address is required"),
      //   monthlyIncome: Yup.number().required("Monthly Income is required"),
      //   incomeSource: Yup.string().required("Income Source is required"),
    }),
    onSubmit: (values) => {
      if (!values.occupation) {
        toast.error("Occupation is required");
        return;
      }
      if (!values.institutionName) {
        toast.error("Company/Institue Name is required");
        return;
      }
      // if (!values.institutionEmail) {
      //   toast.error("Institue Email is required");
      //   return;
      // }
      // if (!values.courseName) {
      //   toast.error("Course Name is required");
      //   return;
      // }
      editOccupationDetailMutate(values);
    },
    enableReinitialize: true,
  });

  const getInputClass = (isDisabled) => {
    return isDisabled
      ? "bg-gray-100 cursor-not-allowed" : "pl-2 relative rounded-md w-full flex items-center border border-gray-400 h-12";
  };

  return (
    <>
      <Wrapper>
        <Title>
          Occupation Details
        </Title>
        <form
          onSubmit={occupationFormik.handleSubmit}
          className="grid grid-cols-1  md:gap-4"
        >
          <CombineInputGroup>
            <InputGroup>
              <Label htmlFor="occupation">Occupation</Label>
              <FieldWrapper>
                <Select
                  id="occupation"
                  name="occupation"
                  className="w-full pl-2"
                  value={occupationFormik.values.occupation}
                  onChange={occupationFormik.handleChange}
                  onBlur={occupationFormik.handleBlur}
                  style={{ height: "46px" }}
                >
                  <MenuItem>
                    <span className="text-gray-400">Select tenant occupation</span>
                  </MenuItem>
                  <MenuItem value="1">Student</MenuItem>
                  <MenuItem value="2">Professional</MenuItem>
                  <MenuItem value="3">Self Employed</MenuItem>
                </Select>
              </FieldWrapper>
            </InputGroup>
            <InputGroup>
              <Label htmlFor="institutionName">Company/Institution Name</Label>
              <FieldWrapper>
                <Input
                  type="text"
                  id="institutionName"
                  name="institutionName"
                  className={getInputClass(false)}
                  value={occupationFormik.values.institutionName}
                  onChange={occupationFormik.handleChange}
                  onBlur={occupationFormik.handleBlur}
                />
              </FieldWrapper>
            </InputGroup>
          </CombineInputGroup>
          <CombineInputGroup>
            <InputGroup>
              <Label htmlFor="institutionEmail">
                Institution/Work Email
              </Label>
              <FieldWrapper>
                <Input
                  type="text"
                  id="institutionEmail"
                  name="institutionEmail"
                  className={getInputClass(false)}
                  value={occupationFormik.values.institutionEmail}
                  onChange={occupationFormik.handleChange}
                  onBlur={occupationFormik.handleBlur}
                />
              </FieldWrapper>
            </InputGroup>
            <InputGroup>
              <Label htmlFor="courseName">Course Name/Designation</Label>
              <FieldWrapper>
                <Input
                  type="text"
                  id="courseName"
                  name="courseName"
                  className={getInputClass(false)}
                  value={occupationFormik.values.courseName}
                  onChange={occupationFormik.handleChange}
                  onBlur={occupationFormik.handleBlur}
                />
              </FieldWrapper>
            </InputGroup>

            {/* <InputGroup>
              <Label htmlFor="monthIncome">Monthly Income (₹)</Label>
              <FieldWrapper>
                <Input
                  type="text"
                  id="monthlyIncome"
                  name="monthlyIncome"
                  value={occupationFormik.values.monthlyIncome}
                  onChange={occupationFormik.handleChange}
                  onBlur={occupationFormik.handleBlur}
                />
                {occupationFormik.touched.monthlyIncome &&
                  occupationFormik.errors.monthlyIncome && (
                    <p className="text-rose-600 text-sm">
                      {occupationFormik.errors.monthlyIncome}
                    </p>
                  )}
              </FieldWrapper>
            </InputGroup> */}
            {/* <InputGroup>
              <Label htmlFor="incomeSource">Income Source</Label>
              <FieldWrapper>
                <Input
                  type="text"
                  id="incomeSource"
                  name="incomeSource"
                  value={occupationFormik.values.incomeSource}
                  onChange={occupationFormik.handleChange}
                  onBlur={occupationFormik.handleBlur}
                />
                {occupationFormik.touched.incomeSource &&
                  occupationFormik.errors.incomeSource && (
                    <p className="text-rose-600 text-sm">
                      {occupationFormik.errors.incomeSource}
                    </p>
                  )}
              </FieldWrapper>
            </InputGroup> */}
          </CombineInputGroup>
          <BtnWrapper>
            <SubmitBtn type="submit" disabled={e ? true : isOccupationDetailLoading} className="text-sm  w-24  md:w-20 h-7 md:text-xs">
              {isOccupationDetailLoading ? "Updating..." : "Update"}
            </SubmitBtn>
          </BtnWrapper>
        </form>

      </Wrapper>
    </>
  );
}

const Wrapper = tw.div`space-y-4 mt-2`;
const Title = tw.h3`text-md md:text-md lg:text-md tracking-wider font-semibold pb-2 text-black`;

const Input = tw.input`truncate border border-gray-300 border-m rounded pl-2 focus:ring-1 focus:ring-sky-600 focus:border-sky-600 focus:outline-none duration-200`;
const FieldWrapper = tw.div`w-full`;
const BtnWrapper = tw.div`w-full flex items-center justify-end mt-4`;
